// Configuração da API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3300/api';

// Helper para obter o token de autenticação do Supabase
const getAuthToken = async () => {
  const { createClient } = await import('../lib/supabase');
  const { supabase } = await import('../lib/supabase');
  const { data: { session } } = await supabase.auth.getSession();
  return session?.access_token || null;
};

// Helper para fazer requisições autenticadas
export const apiRequest = async (endpoint, options = {}) => {
  const token = await getAuthToken();

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Erro desconhecido' }));
    throw new Error(error.message || `Erro ${response.status}`);
  }

  return response.json();
};

export default API_BASE_URL;
